module.exports = __webpack_public_path__ + "img/80658045.700ae36d.png";